var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessGreenBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 59,
    height: 59,
    rx: 11.5,
    fill: "url(#paint0_linear_1016_2453)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 59,
    height: 59,
    rx: 11.5,
    stroke: "url(#paint1_linear_1016_2453)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1016_2453)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1016_2453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 35L25.9412 42.5L43.5 18.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "square"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1016_2453",
    x: 11.3926,
    y: 15.4033,
    width: 37.2036,
    height: 34.2422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1016_2453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1016_2453",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1016_2453",
    x1: 30,
    y1: 0.5,
    x2: 30,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8F09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1016_2453",
    x1: 30,
    y1: 0.5,
    x2: 30,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1016_2453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreenBig);
export default __webpack_public_path__ + "static/media/success-green-big.e91ecf030ee1b850a8eaceaa549d6f46.svg";
export { ForwardRef as ReactComponent };